import styled from 'styled-components';

export const MileWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LabelWrapper = styled.span`
  color: ${({ theme }) => theme.palette.yellow500};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  word-wrap: break-word;
  margin-left: 8px;
`;
